import * as React from 'react';
import Input, { InputProps } from './Input';

const Text = (props: InputProps) => {
	// eslint-disable-next-line react/jsx-props-no-spreading
	return <Input {...props} type="text" />;
};

export default Text;
